module.exports = __webpack_public_path__ + "img/MySQL.bdb502e5.png";